/*
submitBullShit.js
请求bullshit接口
 */
import BaseURL from "../BaseURL";
import {message} from "antd";

const submitBullShit = async (
    {
        query= '',
        answer= '',
        history_query= '',
        history_response= '',
        user= '',
        reasonCode= 0,
        reason= ''}
) => {
    try {
        const response = await BaseURL.post('api/feedback/bullshit/', {
            'query': query,
            'response': answer,
            'history_query': history_query,
            'history_response': history_response,
            'user': user,
            'reason_code': reasonCode,
            'reason': reason,
        });
        const response_data = response.data;
        if (response_data.code === 200) {
            message.success('反馈成功');
        } else {
            message.error('反馈失败，请稍后再试');
        }
    } catch (error) {
        message.error('反馈失败，请稍后再试');
    }
};

export default submitBullShit;